import React from 'react'

const LinkedinIcon = () => {
    return (
        <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M0 1.28925C0 0.577125 0.59175 0 1.32187 0H16.6781C17.4082 0 18 0.577125 18 1.28925V16.7108C18 17.4229 17.4082 18 16.6781 18H1.32187C0.59175 18 0 17.4229 0 16.7108V1.28925ZM5.56087 15.0682V6.94012H2.85975V15.0682H5.56087ZM4.21088 5.82975C5.1525 5.82975 5.73862 5.2065 5.73862 4.42575C5.72175 3.62812 5.15363 3.02175 4.22888 3.02175C3.30413 3.02175 2.7 3.62925 2.7 4.42575C2.7 5.2065 3.28612 5.82975 4.19287 5.82975H4.21088ZM9.73238 15.0682V10.5289C9.73238 10.2859 9.75037 10.0429 9.82238 9.86963C10.017 9.38475 10.4614 8.88188 11.2084 8.88188C12.186 8.88188 12.5764 9.62663 12.5764 10.7201V15.0682H15.2775V10.4062C15.2775 7.90875 13.9455 6.74775 12.168 6.74775C10.7347 6.74775 10.0924 7.53525 9.73238 8.08988V8.118H9.71438C9.72035 8.10861 9.72635 8.09923 9.73238 8.08988V6.94012H7.03237C7.06612 7.70288 7.03237 15.0682 7.03237 15.0682H9.73238Z"
                fill="#2B66BC"
            />
        </svg>


    )
}

export default LinkedinIcon;